module.exports = __webpack_public_path__ + "static/media/self_sacrifice.7362a52c.png";